import React, { useState, useEffect } from 'react'

import {
  Button,
  Icon,
  ChevronLeft,
  ChevronRight,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { objectOf, number, arrayOf, shape, string, oneOf } from 'prop-types'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

import usePerformanceChart from './hooks/usePerformanceChart'

function PerformanceChart({ data, boostPeriods = EMPTY_ARRAY, metricType }) {
  const [ChartComponents, setChartComponents] = useState(null)

  const {
    isMobile,
    chartData,
    options,
    totalPages,
    periodLabel,
    goToPrevious,
    goToNext,
    canGoPrevious,
    canGoNext,
  } = usePerformanceChart(data, boostPeriods, metricType)

  useEffect(() => {
    let mounted = true
    import('react-chartjs-2').then(module => {
      if (mounted) {
        setChartComponents({ Bar: module.Bar, HorizontalBar: module.HorizontalBar })
      }
    })
    return () => { mounted = false }
  }, [])

  if (!ChartComponents) return null

  const ChartComponent = isMobile ? ChartComponents.HorizontalBar : ChartComponents.Bar

  return (
    <>
      <div className={`performance-modal__chart ${isMobile ? 'performance-modal__chart--horizontal' : ''}`}>
        <ChartComponent redraw data={chartData} options={options} />
      </div>
      {isMobile && totalPages > 1 && (
        <div className="performance-modal__pagination">
          <Button
            type="ghost-primary"
            size="large"
            variant="only-icon"
            icon={<Icon svgComponent={ChevronLeft} />}
            onClick={goToPrevious}
            disabled={!canGoPrevious}
            customClass="performance-modal__pagination-btn"
            aria-label="View older data"
          />
          <span className="performance-modal__pagination-label">{periodLabel}</span>
          <Button
            type="ghost-primary"
            size="large"
            variant="only-icon"
            icon={<Icon svgComponent={ChevronRight} />}
            onClick={goToNext}
            disabled={!canGoNext}
            customClass="performance-modal__pagination-btn"
            aria-label="View newer data"
          />
        </div>
      )}
    </>
  )
}

PerformanceChart.propTypes = {
  data: objectOf(number).isRequired,
  // eslint-disable-next-line react/require-default-props
  boostPeriods: arrayOf(shape({
    startDate: string.isRequired,
    endDate: string.isRequired,
  })),
  metricType: oneOf(['views', 'earnings']).isRequired,
}

export default PerformanceChart
